import React from 'react';
import {
    APP_NAME,
    BEIAN_LINK_URL,
    GONGAN_BEIAN_ICON,
    GONGAN_BEIAN_NUMBER,
    ICP_BEIAN_NUMBER,
    MIIT_BEIAN_HOME_URL,
} from '../../constants/appConstants';
import './SiteFooter.css';

/**
 * 全站页脚：版权 + 备案一行（公安图标+编号 | ICP 编号）
 */
class SiteFooter extends React.Component {
    render() {
        const { variant = 'light' } = this.props;
        const year = new Date().getFullYear();

        return (
            <footer className={`site-footer site-footer--${variant}`}>
                <p className="site-footer__copyright">
                    Copyright &copy; {year} {APP_NAME} 版权所有
                </p>
                <p className="site-footer__beian-row">
                    <a
                        className="site-footer__beian-item site-footer__gongan-link"
                        href={BEIAN_LINK_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        title="全国互联网安全管理服务平台"
                    >
                        <img
                            className="site-footer__gongan-icon"
                            src={GONGAN_BEIAN_ICON}
                            alt=""
                            width={18}
                            height={20}
                            decoding="async"
                        />
                        <span>{GONGAN_BEIAN_NUMBER}</span>
                    </a>
                    <a
                        className="site-footer__beian-item site-footer__icp-link"
                        href={MIIT_BEIAN_HOME_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        title="工信部 ICP/IP 地址/域名信息备案管理系统"
                    >
                        {ICP_BEIAN_NUMBER}
                    </a>
                </p>
            </footer>
        );
    }
}

export default SiteFooter;
